/* eslint-disable no-magic-numbers */
import React from 'react';
import './EditElementModal.styles.css';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import {
  elementGlyphStateSelector,
  elementMetaStateSelector,
  elementSubmapStateSelector,
} from '@/redux/modal/modal.selector';
import { modelElementsByModelIdSelector } from '@/redux/modelElements/modelElements.selector';
import { ElementPropertiesForm } from '@/components/FunctionalArea/Modal/EditElementModal/ElementPropertiesForm.component';
import { ElementPreviewPanel } from '@/components/FunctionalArea/Modal/EditElementModal/ElementPreviewPanel.component';

export const EditElementModal: React.FC = () => {
  const elementGlyphState = useAppSelector(elementGlyphStateSelector);
  const elementSubmapState = useAppSelector(elementSubmapStateSelector);
  const elementMetaState = useAppSelector(elementMetaStateSelector);
  const modelElements = useAppSelector(state =>
    modelElementsByModelIdSelector(state, elementMetaState?.model || 0),
  );
  const modelElement = modelElements.find(element => element.id === elementMetaState?.id);

  if (!elementGlyphState || !elementSubmapState || !elementMetaState) {
    throw new Error('Invalid element');
  }

  return (
    <div className="relative flex w-[800px] flex-1 flex-col overflow-hidden border border-t-[#E1E0E6] bg-white p-[24px]">
      <ElementPreviewPanel modelElement={modelElement} />
      <div className="flex flex-1 flex-col gap-6 overflow-y-auto pt-4">
        <ElementPropertiesForm />
      </div>
    </div>
  );
};
